import { Box, Button, Grid, Typography } from "@mui/material";
import Sidebar from "../../components/sidebar/sidebar";
import { Routes, Route, useNavigate, Outlet } from "react-router-dom";
import LoanCollectionTable from "../../components/loanCollectionComponent.js/loanCollectionTable";
import LoanCollection from "../../components/loanCollectionComponent.js/CollectLoan";
import PrincipalCollection from "../../components/loanCollectionComponent.js/CollectPrincipal";

function LoanCollections() {
  const navigate = useNavigate();
  return (
    <div>
      <Box sx={{ display: "flex" }}>
        <Sidebar />
        <Box component="main" sx={{ flexGrow: 1, pt: 3, pr: 2 }}>
          <Box height={65} />
          <Box>
            <Typography variant="h4">Loan Collections</Typography>
          </Box>
          <Box mt={1}>
            <Routes>
              <Route path="/" element={<LoanCollectionTable />} />
              <Route path="/collect-loan" element={<LoanCollection />} />
              <Route
                path="/collect-principal"
                element={<PrincipalCollection />}
              />
            </Routes>
          </Box>
        </Box>
      </Box>
      {/* Outlet is used for rendering nested routes if further nesting is needed */}
      <Outlet />
    </div>
  );
}

export default LoanCollections;
